// apiConfig.js
//  export const BASE_URL = "https://localhost:44354/api";
//  export const Messante_URL = "https://localhost:44348/api";
export const BASE_URL = "https://biz2sms.myconnectlounge.in/api";
export const Messante_URL = "https://gui.growwsaas.com/api";
export const fromdate = "2026-06-09";